import { render, staticRenderFns } from "./promoter-aside.vue?vue&type=template&id=5aa9c44e&"
import script from "./promoter-aside.vue?vue&type=script&lang=js&"
export * from "./promoter-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports